import loadKNB from "./loadKNB"

export async function getFingerprint() {
  await loadKNB()
  if (!window.KNB) {
    console.warn('KNB不存在，请先加载KNB')

    return null
  }

  try {
    const mt_fingerprint = await new Promise(resolve => {
      window.KNB.ready(() => {
        window.KNB.use('getFingerprint', {
          success: (ret) => {
            resolve(ret.fingerprint)
          },
          fail: (err) => {
            console.log(err)
            resolve(null)
          }
        })
      })
    })

    return mt_fingerprint
  } catch(err) {
    console.log(err)

    return null
  }
} 

export async function getAppVersion() {
  await loadKNB()
  if (!window.KNB) {
    console.warn('KNB不存在，请先加载KNB')

    return null
  }
  
  try {
    const version = await new Promise(resolve => {
      window.KNB.ready(() => {
        window.KNB.getAppInfo({
          success: (data) => {
            resolve(data.version)
          },
          fail: (err) => {
            resolve(null)
          }
        })
      })
    })

    return version
  } catch(err) {
    console.log(err)

    return null
  }
}